<template>
  <div>

    <h2>{{ $t('title.' + action + '-external-service') }}</h2>

    <el-row :gutter="40">

      <el-col :span="12">

        <data-form
          model="external-services"
          :entity="externalService"
          :fields="fields"
          :beforeSubmit="mapBeforeSubmit"
          :after-submit="afterSubmit"
          @change="onChange"
          />

      </el-col>

    </el-row>

  </div>
</template>

<script>
export default {
  name: 'external-service-details',
  data () {
    return {
      formModel: null
    }
  },
  computed: {
    fields () {
      const baseFields = {
        'id': {
          type: 'text',
          label: 'name',
          rules: [{ required: true }, { max: 80 }]
        },
        'url': {
          type: 'text',
          rules: [{ required: true }, { max: 80 }]
        },
        'type': {
          type: 'select',
          options: ['event', 'online-validator'].map(i => ({ label: i, value: i })),
          rules: [{ required: true }]
        }
      }

      return {
        ...baseFields,
        ...this.getAdditionalFields(this.formModel || this.externalService)
      }
    },
    externalService () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true, type: 'event' }
      }

      return this.$store.getters['external-services/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.externalService.new ? 'create' : 'edit'
    }
  },
  methods: {
    mapBeforeSubmit (formModel) {
      formModel.config = {
        maxTries: formModel.maxTries,
        timeout: formModel.timeout
      }

      delete formModel.maxTries
      delete formModel.timeout
    },
    afterSubmit () {
      this.$router.back()
    },
    onChange (formModel) {
      this.formModel = formModel
    },
    getAdditionalFields (formModel) {
      if (!formModel) { return }

      switch (formModel.type) {
        case 'event':
        case 'online-validator':
          return {
            'maxTries': {
              type: 'number',
              rules: [{ required: true, type: 'number' }]
            },
            'timeout': {
              type: 'number',
              rules: [{ required: true, type: 'number' }]
            }
          }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ExternalServiceDetails.vue?ad7a9144